import {Funds} from './funds';

export enum SkinPurchaseStatusType {
    Unknown = '',
    Processing = 'processing',
    Delivering = 'delivering',
    Completed = 'completed',
    Settled = 'settled',
    Failed = 'failed',
    Reverted = 'reverted',
}

export enum SkinPurchasePaymentMethodType {
    Unknown = '',
    Wallet = 'wallet',
}

export type SkinPurchaseProviderDetails =
    | { _type: 'skindeck'; ItemId: string; Reference: string };

export interface SkinPurchaseItemDetails {
    ItemId: string;
    ProviderInfo: SkinPurchaseProviderDetails;
    MarketHashName: string;
    Name: string;
    IconUrl: string | null;
    BasePriceCents: number;
    SellPriceCents: number;
    SellMarginBasisPoints: number;
}

export type SkinPurchaseDebitDetails =
    | { _type: 'wallet'; ChargedFunds: Funds; WalletTransactionId: string };

export type SkinPurchaseProcessingDetails =
    | { _type: 'skindeck'; TradeId: string; StartedAt: string };

export enum SkinPurchaseCheckCadenceType {
    Unknown = '',
    Frequent = 'frequent',
    Rare = 'rare',
}

export interface SkinPurchaseCheckDetails {
    Cadence: SkinPurchaseCheckCadenceType;
    LastCheckAt: string;
    LastCheckSuccessful: boolean;
    LastSuccessfulCheckAt: string | null;
}

export type SkinPurchaseCompletionDetails =
    | { _type: 'failed'; CompletedAt: string; Reason: string }
    | { _type: 'success'; CompletedAt: string };

export interface SkinPurchaseReversalDetails {
    RevertedAt: string;
    RefundValueCents: number | null;
}

export type SkinPurchaseRefundDetails =
    | { _type: 'wallet'; WalletTransactionId: string; RefundedFunds: Funds };

export interface SkinPurchaseErrorDetails {
    OccurredAt: string;
    Message: string;
}

export interface SkinPurchaseDetails {
    PurchaseId: string;
    RealmId: string;
    UserId: string;
    Status: SkinPurchaseStatusType;
    PaymentMethod: SkinPurchasePaymentMethodType;
    CreatedAt: string;
    Item: SkinPurchaseItemDetails;
    Debit: SkinPurchaseDebitDetails | null;
    Processing: SkinPurchaseProcessingDetails | null;
    Check: SkinPurchaseCheckDetails | null;
    Completion: SkinPurchaseCompletionDetails | null;
    Reversal: SkinPurchaseReversalDetails | null;
    Refund: SkinPurchaseRefundDetails | null;
    Errors: SkinPurchaseErrorDetails[];
}

export interface SkinDeckCredentials {
    ApiKey: string;
    MerchantId: string;
    MerchantSecret: string;
    BaseUrl: string;
}

export interface SkinDeckSettings {
    Client: SkinDeckCredentials;
    SyncPageSize: number;
    FullSyncIntervalSeconds: number;
    SyncRetryIntervalSeconds: number;
}

export interface SkinPurchaseSettings {
    SettleWindowSeconds: number;
    CheckRunIntervalSeconds: number;
    CheckFrequentMaxAgeSeconds: number;
    CheckFrequentIntervalSeconds: number;
    CheckRareIntervalSeconds: number;
    CheckFailedRetryIntervalSeconds: number;
}

export interface PriceQuoteSettings {
    Secret: string;
    TtlSeconds: number;
}

export interface SteamSettings {
    SkinDeck: SkinDeckSettings;
    Purchase: SkinPurchaseSettings;
    PriceQuote: PriceQuoteSettings;
}

export interface SkinDeckCallbackInfo {
    ReceivedAt: string;
    TradeId: string | null;
    ExternalId: string | null;
    TradeStatus: string | null;
    Outcome: string;
    Body: string;
}

export interface SkinPurchaseSummary {
    PurchaseId: string;
    RealmId: string;
    UserId: string;
    Status: SkinPurchaseStatusType;
    Name: string;
    MarketHashName: string;
    PriceCents: number;
    CreatedAt: string;
    CompletedAt: string | null;
    RefundedFunds: Funds | null;
}
